import { Nullable } from 'types';
import { Funnel } from './types';
import type { Funnelable } from './types';
import type { GeneralLocations } from './general';
import GeneralLocationsImpl from './general';
import type { AccountLocations } from './account';
import AccountLocationsImpl from './account';
import type { LegalLocations } from './legal';
import LegalLocationsImpl from './legal';
import type { OtherLocations } from './other';
import OtherLocationsImpl from './other';
import type { SubscriptionLocations } from './subscription';
import SubscriptionLocationsImpl from './subscription';
import { StudioLocations } from './studio';
import { LibraryLocations } from './library';
import { ReleasesLocations } from './releases/releases';
import { DistributionLocations } from './distribution';

class Locations implements Funnelable {
  account: AccountLocations & Funnelable;

  general: GeneralLocations & Funnelable;

  subscription: SubscriptionLocations & Funnelable;

  legal: LegalLocations & Funnelable;

  studio: StudioLocations;

  distribution: DistributionLocations;

  library: LibraryLocations;

  releases: ReleasesLocations;

  other: OtherLocations & Funnelable;

  constructor(
    account: AccountLocations & Funnelable,
    general: GeneralLocations & Funnelable,
    subscription: SubscriptionLocations & Funnelable,
    legal: LegalLocations & Funnelable,
    studio: StudioLocations,
    distribution: DistributionLocations,
    library: LibraryLocations,
    releases: ReleasesLocations,
    other: OtherLocations & Funnelable
  ) {
    this.account = account;
    this.general = general;
    this.subscription = subscription;
    this.legal = legal;
    this.studio = studio;
    this.distribution = distribution;
    this.library = library;
    this.releases = releases;
    this.other = other;
  }

  funnelsForPathname(pathname: string): Nullable<Funnel[]> {
    const { account, general, subscription, legal, other } = this;

    const accountFunnels = account.funnelsForPathname(pathname);
    if (accountFunnels) return accountFunnels;

    const generalFunnels = general.funnelsForPathname(pathname);
    if (generalFunnels) return generalFunnels;

    const subscriptionFunnels = subscription.funnelsForPathname(pathname);
    if (subscriptionFunnels) return subscriptionFunnels;

    const legalFunnels = legal.funnelsForPathname(pathname);
    if (legalFunnels) return legalFunnels;

    const otherFunnels = other.funnelsForPathname(pathname);
    if (otherFunnels) return otherFunnels;

    const studioFunnels = this.studio.funnelsForPathname(pathname);
    if (studioFunnels) return studioFunnels;

    const distributionFunnels = this.distribution.funnelsForPathname(pathname);
    if (distributionFunnels) return distributionFunnels;

    const libraryFunnels = this.library.funnelsForPathname(pathname);
    if (libraryFunnels) return libraryFunnels;

    const releasesFunnels = this.releases.funnelsForPathname(pathname);
    if (releasesFunnels) return releasesFunnels;

    return null;
  }
}

export const locations: Locations = new Locations(
  new AccountLocationsImpl(),
  new GeneralLocationsImpl(),
  new SubscriptionLocationsImpl(),
  new LegalLocationsImpl(),
  new StudioLocations(),
  new DistributionLocations(),
  new LibraryLocations(),
  new ReleasesLocations(),
  new OtherLocationsImpl()
);
